import { render } from "./edit.vue?vue&type=template&id=18f76e9c&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=18f76e9c&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f76e9c"],['__file',"src/views/widget/shop/product/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18f76e9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18f76e9c', __exports__)) {
    console.log('reload')
    api.reload('18f76e9c', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=18f76e9c&scoped=true", () => {
    console.log('re-render')
    api.rerender('18f76e9c', render)
  })

}


export default __exports__